import { Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-panel',
  templateUrl: './panel.component.html',
  styleUrls: ['./panel.component.css']
})
export class PanelComponent implements OnInit, OnChanges, OnDestroy  {
	@Input() header: string;
	@Input() align: string;
	@Input() opened: boolean;
	@Input() fixed: number[];
	@Input() closeOutOfBoundary: HTMLElement;
	@Input() height: string;
	@Output() didClosed = new EventEmitter<boolean>();
	s: any;
	constructor(private el: ElementRef) {
		if (!this.align) {
			this.align = 'left';
		}
    
	}

	ngOnInit(): void {
		if (!this.s) {
			this.s = {};
		}
	}
	
	ngOnDestroy(): void {
		document.removeEventListener('click', this.handleClickBoundary.bind(this), false);
	}
	private handleClickBoundary(e) {
    if (this.opened && this.el.nativeElement) {
      if (this.closeOutOfBoundary.contains(e.target) ||
        (this.el.nativeElement.children[0] && this.el.nativeElement.children[0].contains(e.target))) {
        // TODO:
      } else {
        this.close();
      }
    }
  }

	ngOnChanges(changes: SimpleChanges): void {
		if ('fixed' in changes) {
			if (this.fixed) {
				if (!this.s) {
					this.s = {};
				}
				this.s.top = this.fixed[1] + 'px';
				if (this.fixed[0] > 0) {
					this.s.left = this.fixed[0] + 'px';
				} else {
					this.s.right = Math.abs(this.fixed[0]) + 'px';
				}
			}
		}
		if ('closeOutOfBoundary' in changes) {
			if (changes.closeOutOfBoundary.currentValue) {
				document.addEventListener('click', this.handleClickBoundary.bind(this), false);
			}
		}
	}

	close() {
		this.opened = false;
		this.didClosed.emit(this.opened);
	}

}
